import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InPurchasesService } from '../../services/inventory/in-purchases.service';
import { DataService } from '../../services/data.service';
import { InProductsService } from '../../../shared/services/inventory/in-products.service';
import { MasterService } from '../../../shared/services/inventory/master.service';
import { InToolsService } from '../../services/inventory/in-tools.service';
export interface Addbulk {
  title: string;
  data: any
  isEdit: boolean
}
@Component({
  selector: 'app-promotionaddbulk',
  templateUrl: './promotionaddbulk.component.html',
  styleUrls: ['./promotionaddbulk.component.css']
})
export class PromotionaddbulkComponent extends DialogComponent<Addbulk, boolean> implements Addbulk, OnInit {
  title: string;
  data: any = []
  isEdit: boolean
  departmentList: any
  categorytList: any
  subcategoryLtist: any
  brandList: any
  dateformat: string = "yyyy-MM-dd"
  chekbox: boolean;
  editdiscount: boolean;
  datetype: string = "date"
  // fillData: any
  result: any = { item: [], result: false };
  model: any = {
    DeptId: 0,
    CatId: 0,
    SubCatId: 0,
    BrandId: 0,
    Editdiscount: false,
    ChkTime: 0,
    DiscountPerc: 0,
    FromDate: new Date,
    ToDate: new Date,
    SupId:0
  }
  supplierList:any;

  constructor(dialogService: DialogService,private ips: InToolsService,private ds: DataService,
    private pds: InProductsService, private ms: MasterService,private ps: InPurchasesService) {
    super(dialogService);
  }

  ngOnInit() {
    this.Department();
    this.Brand();
    this.getsupplier();
    this.fillData = this.data
    for (let i of this.data) {
      if (this.isEdit) {
        var DiscountPerc = i.DiscountPerc
        if (this.data.length == 1) {
          this.model.DiscountPerc = i.DiscountPerc
        }
        else {
          this.data.forEach(rpd => {
            if (rpd.DiscountPerc == DiscountPerc) {
              this.model.DiscountPerc = DiscountPerc
            }
            else {
              this.model.DiscountPerc = 0
            }
          });
        }
      }
      if (i.ChkTime == 1) {
        this.dateformat = "yyyy-MM-ddTHH:mm"
        this.datetype = "datetime-local"
        this.chekbox = true
      }
      else {
        this.dateformat = "yyyy-MM-dd"
        this.datetype = "date"
        this.chekbox = false
      }
    }
  }
  Department() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    };
    this.pds.getDepartment(FilterData).subscribe(res => {
      this.departmentList = [];
      for (let i of res.data) {
        this.departmentList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    },
      (err) => console.error(err),
      () => {
        this.Category()
      });

  }
  Category() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    };
    this.pds.getCategory(FilterData).subscribe(res => {
      this.categorytList = [];
      for (let i of res.data) {
        this.categorytList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    },
      (err) => console.error(err),
      () => {
        this.Subcategory();
      }
    );
  }

  Subcategory() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    };
    this.pds.getSubcategory(FilterData).subscribe(res => {
      this.subcategoryLtist = [];
      for (let i of res.data) {
        this.subcategoryLtist.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
    }, (err) => console.error(err),
      () => {
        this.Brand();
      }
    );
  }
  SelectedDept(e) {
    var deptFilter = {
      DeptId: e.Id,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    };
    this.pds.getCategoryByDept(deptFilter).subscribe(res => {
      this.categorytList = [];
      this.model.CatId = 0
      this.subcategoryLtist = [];
      this.model.SubCatId = 0
      for (let i of res.data) {
        this.categorytList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
      document.getElementById("CatId").focus();
    });
  }
  SelectedCate(e) {
    var deptFilter = {
      DeptId: e.Id,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    };
    this.pds.getSubCategoryBycat(deptFilter).subscribe(res => {
      this.subcategoryLtist = [];
      this.model.SubCatId = 0;
      for (let i of res.data) {
        this.subcategoryLtist.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name,
          Code: i.Code
        });
      }
      document.getElementById("SubCatId").focus();
    },
      (err) => console.error(err),
      () => {

      });
  }

  Brand() {
    var filterData = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.CAType
    };
    this.ms.getBrand(filterData).subscribe(
      res => {
        this.brandList = [];
        for (let i of res.data) {
          this.brandList.push({
            Id: i.Id,
            Name: i.Name
          });
        }
      },
      (err) => console.error(err),
      () => {

      }
    );
  }
  selectBrand() {
    document.getElementById("SupplierId").focus();
  }
  validateAddbulk(): boolean {
    if (this.model.DeptId == 0) {
      alert("Please Select a department")
      document.getElementById("dept").focus()
      return false
    }
    else if (this.model.DiscountPerc == 0) {
      alert("Please enter a valid discount(%)")
      document.getElementById("DPRate").focus()
      return false
    }
    return true;
  }
  LoadAddBulk() {
    if (!this.isEdit) {
      if (this.validateAddbulk()) {
        var request: any = {
          Dept: this.model.DeptId,
          Cat: this.model.CatId,
          SubCat: this.model.SubCatId,
          LocId: this.ds.Settings.LocationId,
          DiscPersc: this.model.DiscountPerc,
          SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
          ChkTime: this.data.ChkTime,
          ReportFilter: {
            FromDate: this.model.FromDate,
            ToDate: this.model.ToDate,
            FilterTypeId: 0,
            FilterType: 0
          },
          BasicFilter: {
            Start: 0,
            FiterText: "",
            Limit: this.ds.Settings.MaxLimit,
            ItemTypeId: this.ds.Settings.ItemTypeId,
            CAType: this.ds.Settings.CAType
          },
          SupId:this.model.SupId,
          BrandId:this.model.BrandId
        }
        this.data = [];
        this.ips.get_PromotionBulk(request).subscribe(res => {
          if (res.Success) {
            for (let i of res.data) {
              if (this.chekbox) {
                i.ChkTime = 1
              }
              else { i.ChkTime = 0 }
              this.data.push(i)
            }
            this.result.result = true
            this.result.item = this.data
            this.close()
          }
          else{
            this.result.result = false;
            this.result.item = [];
            this.close()
          }
        })
      }
    }
    else if (this.model.DiscountPerc == 0) {
      alert("Please enter a valid discount(%)")
      document.getElementById("DPRate").focus()
    }
    else {
      for (let i of this.data) {
        i.DiscountPerc = this.model.DiscountPerc
        i.FromDate = this.model.FromDate
        i.ToDate = this.model.ToDate
        i.LocId = this.ds.Settings.LocationId
        i.CCode = this.ds.Settings.CompanyId
        if (this.chekbox) {
          i.ChkTime = 1
        }
        else { i.ChkTime = 0 }
        this.result.item.push(i)
      }
      this.result.item = this.result.item
      this.result.result = true
      this.close()
    }
  }
  checkchange(e) {
    if (!e) {
      this.dateformat = "yyyy-MM-dd"
      this.datetype = "date"
      this.data.ChkTime = 0
    } else {
      this.dateformat = "yyyy-MM-ddTHH:mm"
      this.datetype = "datetime-local"
      this.data.ChkTime = 1
    }
  }
  confirm(item) {
    this.result = { item: this.data, result: true };
    this.close();
  }
  checkeditdiscountchange(e) {
    if (!e) {
      this.editdiscount = false
    } else {
      this.editdiscount = true
    }
  }
  clear() {
    this.data = {}
    this.model = {
      DeptId: 0,
      CatId: 0,
      SubCatId: 0,
      BrandId: 0,
      Editdiscount: false,
      ChkTime: 0,
      DiscountPerc: 0,
      FromDate: new Date,
      ToDate: new Date,
      SupId:0
    }
    this.chekbox = false
    this.editdiscount = false
  }

  SelectedSubCate(e){
    document.getElementById("BrandId").focus()
  }

  selectSupplier() {
    document.getElementById("DPRate").focus();
  }

  getsupplier() {
    var FilterData: any = {
      Start: 0,
      FiterText: "",
      Limit: this.ds.Settings.MaxLimit,
      ItemTypeId: this.ds.Settings.ItemTypeId,
      CAType: this.ds.Settings.ItemTypeId
    };
    this.ps.getSupplier(FilterData).subscribe(res => {
      this.supplierList = [];
      for (let i of res.data) {
        this.supplierList.push({
          Id: i.Id,
          Name: i.Code + " - " + i.Name
        });
      }
    });
  }

}





// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/promotionaddbulk/promotionaddbulk.component.ts